import { IconSearch } from '@tabler/icons-react'
import { Button, Input, Space } from 'antd'
import React from 'react'
import { Text, View } from 'styles/reactnative'
import { ThemeContext } from 'theme/ThemeProvider'

const SearchFilter = ({ search, setSearch, search2, setSearch2, width='auto' }) => {
	const { theme } = React.useContext(ThemeContext)
	return (
		<View
			style={{
				backgroundColor: theme.COLORS.descBox,
				flexDirection: 'row',
				padding: '2px 2px',
				borderRadius: 5,
				gap: 2,
				width: width,
				justifyContent: 'flex-start',
			}}>
			<Text
				style={{
					fontWeight: 'bold',
					fontSize: 11,
					color: theme.COLORS.textw,
					backgroundColor: theme.COLORS.descBox,
					borderRadius: 5,
					borderTopRightRadius: 0,
					borderBottomRightRadius: 0,
					padding: '4px 2px',
					whiteSpace:'nowrap'
				}}>
				검색
			</Text>
			<View
				style={{
					flexDirection: 'row',
					color: theme.COLORS.textw,
					backgroundColor: theme.COLORS.background,
					borderRadius: 5,
					borderTopLeftRadius: 0,
					borderBottomLeftRadius: 0,
					padding: '2px 2px',
				}}>
				<Space.Compact
					size="small"
					style={{
						alignItems: 'center',
						whiteSpace: 'nowrap',
						fontSize: 10,
					}}>
					<Input
						size="small"
						value={search}
						style={{ width: 80 }}
						onChange={e => setSearch(e.target.value)}
						onKeyDown={e => {
							if (e.key === 'Enter') {
								setSearch2(search)
							}
						}}
					/>
					{search2 && (
						<Button
							size="small"
							danger
							onClick={() => {
								setSearch('')
								setSearch2('')
							}}>
							X
						</Button>	
					)}

					<Button
						icon={<IconSearch />}
						size="small"
						onClick={() => {
							setSearch2(search)
						}}
					/>

				</Space.Compact>
			</View>
		</View>
	)
}

export default React.memo(SearchFilter)
